export default __webpack_public_path__ + "static/media/JMPLogo.bff30287.png";